import React from "react";

export const actions = {
    SET: 'set',
}

export function localeReducer(state, action) {
    switch (action.type) {
        case actions.SET: 
            return {state, ...action.data} 
        default: {
            throw Error('Unknown action: ' + action.type);
        }
    }
}

const initState = {
    currentLanguage: null
}
export default function LocaleReducer() {   
    const [{currentLanguage}, dispatch] = React.useReducer(localeReducer, initState)
    const setCurrentLanguage = (lang) => dispatch({
        type: actions.SET,
        data: {
            currentLanguage: lang
        }
    })
    return {
        currentLanguage,
        setCurrentLanguage
    }
}